import { Box } from '@material-ui/core'
import { Button } from 'components/facets'
import { getPriceFormat } from 'lib/utils'
import moment from 'moment'
import { useState } from 'react'
import { CSVLink } from 'react-csv'
import {
  CardLanguage,
  escapeDoubleQuotes,
  getDisplayLocationName,
  OrderArticle,
  OrderIssue,
} from 'shared'
interface ExportPickingListProps {
  articlesToPick: OrderArticle[]
  articlesPicked: OrderArticle[]
  pickingListId: number
}

interface CsvOrderArticleItem {
  status: string
  orderBin: string
  count: number
  category: string | undefined
  cn: string | undefined
  color: string | undefined
  expansionCode: string | undefined
  expansionName: string | undefined
  englishName: string
  localizedName: string
  language: string
  finishType: string
  isSigned: boolean
  isAltered: boolean
  condition: string
  price: string
  comments: string
  issues: string | undefined
  locationWherePick: string | undefined
  quantityToPickInLocation: number | undefined
  totalPickedQuantity: string | undefined
}

export const ExportPickingList = ({
  articlesPicked,
  articlesToPick,
  pickingListId,
}: ExportPickingListProps): JSX.Element => {
  const [articlesToPickData, setArticlesToPickData] = useState<CsvOrderArticleItem[]>([])
  const [articlesPickedData, setArticlesPickedData] = useState<CsvOrderArticleItem[]>([])

  const fileFormats = ['csv', 'xlsx']
  const fileFormat = fileFormats[0]

  const getTextIssues = (issues: OrderIssue[]) => {
    const textIssues = issues.map((i) => i.description)
    return textIssues.join('\n')
  }

  const handleDownloadArticlesToPick = (done: (proceed: boolean | undefined) => void): void => {
    setArticlesToPickData(
      articlesToPick.map((a) => {
        const row: CsvOrderArticleItem = handleRow(a)
        return row
      })
    )
    if (window.Cypress) done(false)
    else done(true)
  }

  const handleDownloadArticlesPicked = (done: (proceed: boolean | undefined) => void): void => {
    setArticlesPickedData(
      articlesPicked.map((a) => {
        const row: CsvOrderArticleItem = handleRow(a)
        return row
      })
    )
    if (window.Cypress) done(false)
    else done(true)
  }

  const handleRow = (a: OrderArticle) => {
    return {
      status: a.articleState?.toUpperCase(),
      orderBin: a.pickingId!,
      count: a.quantity,
      category: a.card.categoryName,
      cn: a.card.cn ?? '',
      color: a.card.colors,
      expansionCode: a.card.set,
      expansionName: escapeDoubleQuotes(a.card.expansion),
      localizedName: escapeDoubleQuotes(a.getLocalizedName()),
      englishName: escapeDoubleQuotes(a.card.name),
      language: CardLanguage[a.idLanguage],
      condition: a.condition,
      price: getPriceFormat(a.price, a.currencyCode),
      comments: a.comment,
      finishType: a.finishType,
      isSigned: a.isSigned,
      isAltered: a.isAltered,
      issues: getTextIssues(a.issues),
      locationWherePick: getDisplayLocationName(a.locationInfo?.name ?? ''),
      quantityToPickInLocation: a.locationInfo?.deltaQuantity
        ? Math.abs(a.locationInfo.deltaQuantity)
        : undefined,
      totalPickedQuantity: `${a.pickedQuantity} /${a.quantity} `,
    }
  }

  const fileName = `${pickingListId}-${moment(Date.now()).format('DD-MM-YYYY_HH-mm')}.${fileFormat}`

  return (
    <>
      <Box marginTop={1}>
        <CSVLink
          data={articlesToPickData}
          asyncOnClick={true}
          onClick={(_event, done) => {
            handleDownloadArticlesToPick(done)
          }}
          enclosingCharacter={`"`}
          filename={`articles-toPick-${fileName}`}
          style={{ textDecoration: 'none' }}
        >
          <Button fullWidth variant="contained" color="primary">
            Downlaod articles to pick
          </Button>
        </CSVLink>

        <Box marginY={2}>
          <CSVLink
            data={articlesPickedData}
            asyncOnClick={true}
            onClick={(_event, done) => {
              handleDownloadArticlesPicked(done)
            }}
            enclosingCharacter={`"`}
            filename={`articles-picked-${fileName}`}
            style={{ textDecoration: 'none' }}
          >
            <Button fullWidth variant="contained" color="primary">
              Download picked articles
            </Button>
          </CSVLink>
        </Box>
      </Box>
    </>
  )
}
